<ion-select
  label="Firma"
  label-placement="floating"
  fill="outline"
  (ionChange)="selectedItemChanged.emit($event.detail.value)"
  [multiple]="multiple"
  [value]="preselectedItem"
  mode="md"
  interface="popover"
>
  <ion-select-option [value]="null" *ngIf="showAllEntry"
    >Alle Firmen</ion-select-option
  >
  <ion-select-option *ngFor="let item of this.items | async" [value]="item">{{
    item.name
  }}</ion-select-option>
</ion-select>
